export default __webpack_public_path__ + "static/media/Maduro-3.c8acd363.png";